import { IconButton, PanelHeader, Text, Tooltip } from "@aurem/ui";
import ROUTES from "const/routes";
import { FolderClock } from "lucide-react";
import { useI18n } from "providers/I18nProvider";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { useChatPanel } from "root/ChatPanelProvider";

export const ChatPanelHeader: FC = () => {
  const { t } = useI18n();
  const chatCtx = useChatPanel();
  const navigate = useNavigate();

  const viewChat = () => {
    void navigate(`/${ROUTES.CHATS}`);
    chatCtx.setIsOpen(false);
  };

  return (
    <PanelHeader className="p-2 ps-4">
      <Text size="sm" weight="medium" className="text-neutral-500 flex-1">
        {t("apps.admin.chatAI.ui.assistantTitle")}
      </Text>
      <Tooltip
        placement="bottom"
        contentClassName="p-2"
        content={t("apps.admin.chatAI.ui.viewAllChat")}
      >
        <IconButton
          variant="ghost"
          color="neutral"
          size="md"
          onClick={viewChat}
          aria-label={t("apps.admin.chatAI.ui.viewAllChat")}
        >
          <FolderClock size="1rem" />
        </IconButton>
      </Tooltip>
    </PanelHeader>
  );
};
